import { connect } from 'react-redux'
import Contributor from './contributor'
import { getContributor } from '../../../../../../../stores/assessment-file/assessment-file.selectors'

const mapStateToProps = (state, { id }) => {
  const contributor = getContributor(state, id)
  return {
    id,
    name: contributor.full_name,
    avatar: contributor.avatar
  }
}

export default connect(
  mapStateToProps,
  null
)(Contributor)
